import { dashboardEnvProblems } from './envCheck.mjs';

/**
 * Browser stand-in for the Expo `lib/config.ts`.
 *
 * `src/shared/api.ts` is a symlink to the repo's `lib/api.ts` so the dashboard
 * and the mobile app share one definition of every API type. That file imports
 * `./config` and `./auth`, which on Expo read from `expo-constants` and
 * AsyncStorage; these two modules give it the same shape backed by Vite env and
 * the browser Supabase client instead.
 *
 * Vite replaces every `import.meta.env.VITE_*` access below with a literal at
 * build time, so this object is exactly what the served bundle will use.
 */

// The localhost fallback lives only in the dev branch. `import.meta.env.DEV` is
// a compile-time `false` in a production build, so the string is dead code and
// never reaches the emitted JS — ops/smoke.sh greps the live bundle for it.
const devApiUrl = import.meta.env.DEV ? 'http://localhost:3000' : '';

export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? devApiUrl,
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY ?? '',
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
  devToken: import.meta.env.VITE_DEV_TOKEN ?? '',
};

/**
 * Problems with the env this bundle was built from. Always empty in dev (`vite`,
 * vitest, `vite build --mode development`). In a production-style build the
 * guard plugin in vite.config.ts should already have refused to emit anything;
 * if a bad bundle is served anyway, main.tsx renders this list instead of the
 * app rather than quietly calling localhost from a public origin.
 */
export const configProblems: readonly string[] = import.meta.env.DEV
  ? []
  : dashboardEnvProblems(
      {
        VITE_API_URL: import.meta.env.VITE_API_URL,
        VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
        VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
        VITE_DEV_TOKEN: import.meta.env.VITE_DEV_TOKEN,
      },
      { allowLocal: false },
    );

export const supabaseConfigured = !!(config.supabaseUrl && config.supabaseAnonKey);
